import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./style.scss";
import { gql, useMutation } from "@apollo/client";

const FORGOT_MUTATION = gql`
  mutation forgotPasswordToken($email: String!) {
    forgotPasswordToken(email: $email) {
      status
    }
  }
`;

function Forget() {
  const [querys, { loading }] = useMutation(FORGOT_MUTATION);
  const [isValid, setIsValid] = useState("");
  const [variant, setVariant] = useState("danger");
  const [inputForm, setForm] = useState({
    email: "",
  });

  let formChange = (event) => {
    const values = { ...inputForm };
    values[event.target.name] = event.target.value;
    setForm(values);
  };

  const submitForm = (event) => {
    if (event) event.preventDefault();

    const values = { ...inputForm };
    if (!values.email) {
      setVariant("danger");
      return setIsValid("Please fill the field");
    }

    setIsValid("");
    querys({ variables: { ...values } })
      .then((res) => {
        if (res.data?.forgotPasswordToken?.status) {
          setVariant("success");
          setIsValid(
            "Request successful. Please check your email for the reset link."
          );
        } else {
          setVariant("danger");
          setIsValid("Request failed. Account not found or email could not be sent.");
        }
      })
      .catch(() => {
        setVariant("danger");
        setIsValid("Request failed. Please try again later.");
      });
  };

  return (
    <div id="forget">
      {isValid ? <Alert variant={variant}>{isValid}</Alert> : ""}
      <div className="d-flex align-items-center auth px-0 mt-5">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <form onSubmit={submitForm}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={inputForm.email}
                  onChange={(e) => formChange(e)}
                />
              </Form.Group>
              <div className="ctdc-btn">
                <Button
                  className="submit-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </form>

            <Link to="/login">Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forget;
